import styled from 'styled-components';
import { Box, spacing } from '@landr/maestro';

export const CardsGroup = styled(Box)`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 192px));
    grid-column-gap: ${spacing('xl')};
    margin-top: ${spacing('xxl')};
    margin-bottom: ${spacing('xxl')};

    ${({ theme }): string => theme.breakpoint('lg')`
        grid-template-rows:  repeat(2,minmax(0, 100%));
        grid-template-columns: repeat(3, minmax(0, 100%));
        grid-row-gap: ${spacing('sm')};
        grid-column-gap: ${spacing('sm')};
        margin-top: ${spacing('xl')};
        margin-bottom: ${spacing('xl')};
    `}

    ${({ theme }): string => theme.breakpoint('sm')`
        grid-template-rows: repeat(3, minmax(0, 100%));
        grid-template-columns: repeat(2, minmax(0, 100%));
    `}
`;
